import React, { useCallback } from "react";
import client from "@culturehq/client";
import { Icon, Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { useFetch } from "app/hooks";
import { EventLink } from "app/links";
import { Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";
import { Time } from "components/common/Time";

const SuggestedEvent = ({ event }) => (
  <div className="SidePanel__row">
    <div className="SidePanel__row__date">
      <div className="month">
        <Time time={event.startsAt} format="%b" />
      </div>
      <div className="day">
        <Time time={event.startsAt} format="%d" />
      </div>
    </div>
    <div className="SidePanel__row__details">
      <EventLink event={event} />
      <p className="SidePanel__row__time">
        <Time time={event.startsAt} format="%l:%M %p" />
      </p>
    </div>
  </div>
);

const SuggestedEventsType = ({ children, onFetch }) => {
  const { fetching, json } = useFetch(onFetch);
  const { events = [] } = json;

  if (!fetching && events.length < 1) {
    return null;
  }

  return (
    <Panel className="SidePanel">
      <Panel.Heading>
        {children}
      </Panel.Heading>
      <Panel.LoaderBody loading={fetching}>
        <ErrorBoundary>
          {events && events.slice(0, 5).map(event => (
            <SuggestedEvent key={event.id} event={event} />
          ))}
        </ErrorBoundary>
      </Panel.LoaderBody>
    </Panel>
  );
};

const SuggestedEvents = () => {
  const { profile: { id: userId } } = useProfile();

  const onFetchUpcoming = useCallback(
    () => client.listUserRsvpdEvents({ userId, when: "future", sort: "+starts_at" }),
    [userId]
  );

  const onFetchHosting = useCallback(
    () => client.listUserHostedEvents({ userId }),
    [userId]
  );

  return (
    <>
      <SuggestedEventsType onFetch={client.listTrendingEvents}>
        <Icon icon="arrow-graph-up-right" />
        <Trans>Trending</Trans>
      </SuggestedEventsType>
      <SuggestedEventsType onFetch={onFetchUpcoming}>
        <Icon icon="calendar-clock" />
        <Trans>My Upcoming</Trans>
      </SuggestedEventsType>
      <SuggestedEventsType onFetch={onFetchHosting}>
        <Icon icon="calendar-gear" />
        <Trans>My Hosted</Trans>
      </SuggestedEventsType>
    </>
  );
};

export default SuggestedEvents;
